import gql from 'graphql-tag';

export default gql`
  mutation productSetDiscountPrice($input: PricingInput!) {
    productSetDiscountPrice(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
